<template>
    <div
        v-if="atLeastOnePromoIsDisabledForLabels"
        class="flex-grow-1 text-sm a-infoBar a-infoBar--warning mb-3"
    >
        Wśród aktywowanych promocji znajduje się przynajmniej jedna
        promocja, dla której cenówki nie są obsługiwane

        <a-icon
            icon="Info"
            style="width: 16px; height: 16px; margin-left: 4px; position: relative; top: 3px;"
            v-tooltip="tooltip"
        />
    </div>
</template>

<script>
export default {
    name: 'DisabledLabelsWarning',

    props: {
        acceptedPromos: {
            type: Array,
            required: true
        }
    },

    computed: {
        enableTypes() {
            return this.$store.getters.getLabelPromoTypes
        },

        atLeastOnePromoIsDisabledForLabels() {
            // check if at least one promo is disabled for labels
            return this.acceptedPromos.some(({ type }) =>
                !this.enableTypes.includes(type)
            )
        },

        tooltip() {
            const promoTypes = this.$store.getters.getPromoTypes

            // get difference between all promo types and enabled types
            const disabledTypes = promoTypes.filter(
                ({ type }) => !this.enableTypes.includes(type)
            )

            let html = `
                <p class="mb-1">Nieobsługiwane typy:</p>
                <ul class="text-left">
            `

            disabledTypes.forEach(({ name }) => {
                html += `<li>${name}</li>`
            })

            html += '</ul>'

            return html
        }
    }
}
</script>